import { create } from 'zustand';
import { getDecisionTreeCsvFromStorage, getIncludeCalculationsFromStorage } from './decision-tree-storage';
import { DecisionTree } from '../domain/tree/decision-tree';
import { DecisionTreeTable } from '../domain/table/decision-tree-table';
import { DecisionTreeTableColumnType } from '../domain/table/decision-tree-table-column';
import { BinningOption } from '../interfaces';

const initialCsv = getDecisionTreeCsvFromStorage() || `
המתנת לקוח  ,זמן המתנה משוער  ,סוג מסעדה  ,הזמנה מראש  ,חמסין  ,רמת מחירים  ,תפוסת לקוחות במסעדה  ,לקוח רעב  ,סוף שבוע  , בר  ,מסעדה חלופית  ,מס' לקוח
כ  ,  0-10, צרפתי  ,כ  ,ל  ,גבוהה  ,בינונית ,כ  ,ל  ,ל  ,כ  ,1
ל  , 30-60,אסייתי  ,ל  ,ל  ,נמוכה  ,  ?,כ  ,ל  ,ל  ,כ  ,2
כ  ,  0-10,מזרחי  ,ל  ,ל  ,נמוכה  ,בינונית ,ל  ,ל  ,כ  ,ל  ,3
כ  ,  ?,אסייתי  ,ל  ,ל  ,נמוכה  ,מלאה  ,כ  ,כ  ,ל  ,כ  ,4
ל  ,  > 60, צרפתי  ,כ  ,ל  ,גבוהה  ,מלאה  ,ל  ,  ?,ל  ,כ  ,5
כ  ,  0-10,איטלקי ,כ  ,כ  ,בינונית ,בינונית ,כ  ,ל  ,כ  ,ל  ,6
ל  ,  0-10,  ?,ל  ,כ  ,נמוכה  ,ריק  ,ל  ,ל  ,כ  ,ל  ,7
כ  ,  0-10,אסייתי  ,כ  ,כ  ,בינונית ,בינונית ,כ  ,ל  ,ל  ,ל  ,8
ל  ,  > 60,מזרחי  ,ל  ,כ  ,נמוכה  ,מלאה  ,ל  ,כ  ,ל  ,ל  ,9
ל  , 10-30,איטלקי ,כ  ,ל  ,גבוהה  ,מלאה  ,כ  ,כ  ,כ  ,כ  ,10
ל  ,  0-10,אסייתי  ,ל  ,ל  ,נמוכה  ,ריק  ,ל  ,ל  ,כ  ,ל  ,11
כ  , 30-60,מזרחי  ,ל  ,ל  ,נמוכה  ,מלאה  ,כ  ,כ  ,כ  ,כ  ,12
    `;

interface DecisionTreeState {

    csv: string;
    setCsv: (_csv: string) => void;

    decisionTree: DecisionTree|null;
    setDecisionTree: (_decisionTree: DecisionTree|null) => void;

    decisionTreeTable: DecisionTreeTable|null;
    setDecisionTreeTable: (_decisionTreeTable: DecisionTreeTable|null) => void;

    includeCalculations: boolean;
    setIncludeCalculations: (_includeCalculations: boolean) => void;

    columnsRewrittenTypes: Map<string, DecisionTreeTableColumnType>;
    setColumnsRewrittenTypes: (_columnsRewrittenTypes: Map<string, DecisionTreeTableColumnType>) => void;

    binningGroupsCount: Map<string, number>;
    setBinningGroupsCount: (_binningGroupsCount: Map<string, number>) => void;

    forceBinningColumns: Map<string, BinningOption>;
    setForceBinningColumns: (_forceBinningColumns: Map<string, BinningOption>) => void;

    binningByDepth: string[];
    setBinningByDepth: (_binningByDepth: string[]) => void;

    excludedColumns: string[];
    setExcludedColumns: (_excludedColumns: string[]) => void;
}

export const useDecisionTreeStore = create<DecisionTreeState>()((set) => ({

    csv: initialCsv,
    setCsv: (_csv: string) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                csv: _csv,
            };
        });
    },

    decisionTree: null,
    setDecisionTree: (_decisionTree: DecisionTree|null) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                decisionTree: _decisionTree,
            };
        });
    },

    decisionTreeTable: null,
    setDecisionTreeTable: (_decisionTreeTable: DecisionTreeTable|null) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                decisionTreeTable: _decisionTreeTable,
            };
        });
    },

    includeCalculations: getIncludeCalculationsFromStorage(),
    setIncludeCalculations: (_includeCalculations: boolean) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                includeCalculations: _includeCalculations,
            };
        });
    },

    columnsRewrittenTypes: new Map(),
    setColumnsRewrittenTypes: (_columnsRewrittenTypes: Map<string, DecisionTreeTableColumnType>) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                columnsRewrittenTypes: _columnsRewrittenTypes,
            };
        });
    },

    forceBinningColumns: new Map(),
    setForceBinningColumns: (_forceBinningColumns: Map<string, BinningOption>) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                forceBinningColumns: _forceBinningColumns,
            };
        });
    },

    binningByDepth: [],
    setBinningByDepth: (_binningByDepth: string[]) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                binningByDepth: _binningByDepth,
            };
        });
    },

    excludedColumns: [],
    setExcludedColumns: (_excludedColumns: string[]) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                excludedColumns: _excludedColumns,
            };
        });
    },

    binningGroupsCount: new Map(),
    setBinningGroupsCount: (_binningGroupsCount: Map<string, number>) => {
        return set((state: DecisionTreeState) => {
            return {
                ...state,
                binningGroupsCount: _binningGroupsCount,
            };
        });
    },
}))